// ===========================================================================
// AI Clinical Notes — feature flag del módulo.
//
// DEV-ONLY desde 2026-08-31: el módulo queda fuera de producción hasta nuevo
// aviso. El gating se hace contra `process.env.NODE_ENV`, igual que playground,
// membership y cash:
//   - `yarn start`  → NODE_ENV = "development"  → CLINICAL_NOTE_AI_ENABLED = true
//   - `yarn build`  → NODE_ENV = "production"   → CLINICAL_NOTE_AI_ENABLED = false
//
// Como CRA fuerza NODE_ENV en cada comando, no hay env var que alguien pueda
// togglear por error. En el bundle de producción NI la ruta NI el ítem del
// sidebar se registran, así que tampoco se llega por URL directa — es lo que
// separa "oculto" de "inaccesible".
//
// El módulo conserva su mapeo RBAC (`ai_clinical_notes`, 16) en
// app/AccessDenied/roleRoutePermissions.js: en desarrollo la ruta sigue
// gateada, y cuando se reactive en producción no hay nada más que tocar.
//
// PARA REACTIVARLO EN PRODUCCIÓN: cambiar esta constante por `true` (o por la
// condición que corresponda) — el índice del módulo y el sidebar la leen los dos.
// ===========================================================================

export const CLINICAL_NOTE_AI_ENABLED = process.env.NODE_ENV === "development";

export const CLINICAL_NOTE_AI_BASE_PATH = "/ClinicalNoteAi";
